// Naming many tables at once (slice 66, ADR 0066): "T" and 1 to 20 become T1 … T20.
//
// Only the names are worked out here; the server checks each one again, skips a name
// already in use and makes a table (with its own random QR code) for the rest.

export const BULK_MAX = 100;
const LABEL_MAX = 20;
const NUMBER_MAX = 9999;

export type BulkPlan =
  | { readonly ok: true; readonly labels: readonly string[] }
  | { readonly ok: false; readonly reason: string };

function whole(text: string): number | null {
  const t = text.trim();
  if (!/^\d{1,6}$/.test(t)) return null;
  return Number.parseInt(t, 10);
}

export function planBulkLabels(prefix: string, from: string, to: string): BulkPlan {
  const start = whole(from);
  const end = whole(to);
  if (start === null || end === null) {
    return { ok: false, reason: 'Enter whole numbers for the first and last table.' };
  }
  if (start > NUMBER_MAX || end > NUMBER_MAX) {
    return { ok: false, reason: `Numbers go up to ${NUMBER_MAX}.` };
  }
  if (end < start) return { ok: false, reason: 'The last number must not be below the first.' };
  const count = end - start + 1;
  if (count > BULK_MAX) {
    return { ok: false, reason: `Add up to ${BULK_MAX} tables at a time.` };
  }
  const p = prefix.trim();
  if ([...p].some((ch) => ch.charCodeAt(0) <= 0x1f || ch.charCodeAt(0) === 0x7f)) {
    return { ok: false, reason: 'The name cannot contain control characters.' };
  }
  const labels = Array.from({ length: count }, (_, i) => `${p}${start + i}`);
  if (labels.some((l) => l.length > LABEL_MAX)) {
    return { ok: false, reason: `A table name is at most ${LABEL_MAX} characters.` };
  }
  return { ok: true, labels };
}
